import { useContext } from "react";
import { ProductContext } from "./ProductList";

/**
 * Retrieves the optional product context.
 *
 * @returns {Object} The product context.
 * @throws {Error} If the product context is not provided.
 */
const useOptionalProductContext = () => {
  try {
    const context = useContext(ProductContext);
    if (context === undefined) {
      throw new Error("ProductContext not provided");
    }
    return context;
  } catch (e) {
    return {
      products: [],
      setProducts: () => {},
    };
  }
};

export default useOptionalProductContext;
